import { Controller } from "@hotwired/stimulus"

// Dynamiczne wiersze akcji reguły automatyzacji: dodawanie/usuwanie z template
// oraz przełączanie pól wiersza (flow / predefiniowana) zależnie od rodzaju akcji.
// Pola ukrytej sekcji są disabled, żeby nie trafiały do parametrów.
export default class extends Controller {
  static targets = ["list", "template"]

  connect() {
    this.counter = this.rows().length
    this.rows().forEach((row) => this.toggleKind(row))
  }

  add() {
    const html = this.templateTarget.innerHTML.replace(/__INDEX__/g, this.counter)
    this.counter++
    this.listTarget.insertAdjacentHTML("beforeend", html)
    const rows = this.rows()
    this.toggleKind(rows[rows.length - 1])
  }

  remove(event) {
    event.target.closest(".action-row").remove()
  }

  kindChanged(event) {
    this.toggleKind(event.target.closest(".action-row"))
  }

  rows() {
    return Array.from(this.listTarget.querySelectorAll(".action-row"))
  }

  toggleKind(row) {
    const kind = row.querySelector("[data-action-kind]").value
    this.toggleWrap(row.querySelector("[data-action-flow]"), kind === "flow")
    this.toggleWrap(row.querySelector("[data-action-predefined]"), kind === "predefined")

    // pola zależne od wybranej akcji predefiniowanej (notification / start_escalation)
    if (kind === "predefined") {
      const action = row.querySelector("[data-predefined-action]").value
      this.toggleWrap(row.querySelector("[data-predefined-notification]"), action === "notification")
      this.toggleWrap(row.querySelector("[data-predefined-start-escalation]"), action === "start_escalation")
      this.toggleWrap(row.querySelector("[data-predefined-send-template]"), action === "send_template")
      this.toggleWrap(row.querySelector("[data-predefined-send-sms]"), action === "send_sms")
      this.toggleWrap(row.querySelector("[data-predefined-send-chat]"), action === "send_chat")
      this.toggleWrap(row.querySelector("[data-predefined-create-task]"), action === "create_task")
      this.toggleWrap(row.querySelector("[data-predefined-update-record]"), action === "update_record")
      this.toggleWrap(row.querySelector("[data-predefined-send-webhook]"), action === "send_webhook")
      this.toggleWrap(row.querySelector("[data-predefined-digest]"), action === "digest")
    }
  }

  toggleWrap(wrap, visible) {
    if (!wrap) return
    wrap.classList.toggle("hidden", !visible)
    wrap.querySelectorAll("select, input").forEach((el) => {
      el.disabled = !visible
    })
  }
}
